import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { updateExchangeSettingsDetails } from "../../redux/slices";
import { exchangeSettingsActionTypes } from "../../redux/utils";
import { HeaderText, Button } from "../";
import { useOrderContext, useAppContext } from "../../contexts";
import { useAPI, useHardCode } from "../../hooks";
import { IoMdClose } from "react-icons/io";

export const UploadImg = () => {
  const [multiImg, setMultiImg] = useState([]);
  const [multi, setMulti] = useState();
  const [isError, setIsError] = useState(false);
  const [isLoader, setIsLoader] = useState(true);
  const [isVideo, setIsVideo] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const { isInternalServerError, setIsInternalServerError } = useAppContext();
  const FILESIZELIMIT = 10485760; //10MB file size limit
  const { UPLOAD_IMAGE_API } = useAPI();
  const dispatch = useDispatch();
  const exchangeSettingsState = useSelector((state) => state.exchangeSettings);
  const storeConfigState = useSelector((state) => state.storeSettings);
  const otherSettingsState = useSelector((state) => state.otherSettings);
  const isBtnDisabled = !otherSettingsState.isImgOptional ? isLoader : false;
  const refundSettingsState = useSelector((state) => state.refundSettings);
  const { SHOPIFY_SHOP_OBJECT, CURRENT_STORE_NAME, PURE_FEMALE_TRANSLATION } =
    useHardCode();
  const isPureFemale = SHOPIFY_SHOP_OBJECT === CURRENT_STORE_NAME.pure_female;
  const error_message_size = isPureFemale
    ? PURE_FEMALE_TRANSLATION.upload_image.error_message_size
    : "File Should be less than 10 MB";
  const error_message_type = isPureFemale
    ? PURE_FEMALE_TRANSLATION.upload_image.error_message_type
    : "Only image is allowed";

  const getBase64 = async (file) => {
    const response = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result);
      reader.onerror = (error) => reject(error);
    });

    return response;
  };

  const setImgPreview = async (e) => {
    const getFileType = e.target.files[0].type.slice(0, 5);
    const getFileSize = e.target.files[0].size;
    getFileType === "video" ? setIsVideo(true) : setIsVideo(false);

    setIsLoader(true);
    if (
      (getFileType === "image" || getFileType === "video") &&
      getFileSize <= FILESIZELIMIT
    ) {
      setIsError(false);
      setErrorMsg("");
      if (e.target?.files[0]) {
        const response = await getBase64(e.target.files[0]);
        setIsLoader(response);

        // dispatch(
        //   updateExchangeSettingsDetails({
        //     key: exchangeSettingsActionTypes.UPDATE_IMAGE_LIST,
        //     value: [...multiImg, response],
        //   })
        // );

        setMultiImg((prevState) => {
          return [...prevState, response];
        });
      }
    } else {
      setIsError(true);
      getFileSize > FILESIZELIMIT
        ? setErrorMsg(error_message_size)
        : setErrorMsg(error_message_type);
    }
  };

  const [showAddMore, setShowAddMore] = useState(false);
  const { setIsSelected } = useOrderContext();
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      try {
        const response = exchangeSettingsState.isMultipleImagesUpload;

        if (response) {
          setMulti(response);
        } else {
          setMulti(false);
        }
      } catch (err) {
        console.log(`${err}:unable to set  state`);
      }
    })();
  }, []);

  const removeImgHandler = (imageID) => {
    if (multiImg?.length) {
      //Delete item
      const filterID = multiImg.filter((imgID, index) => index !== imageID);

      setMultiImg(filterID);
      setIsLoader(true);
    }
  };

  useEffect(() => {
    multiImg?.length > 0 ? setIsSelected(true) : setIsSelected(false);

    multiImg?.length > 0 && multi === true
      ? setShowAddMore(true)
      : setShowAddMore(false);
  }, [multiImg, setIsSelected, multi]);

  useEffect(() => {
    if (multiImg.length > 0) {
      (async () => {
        try {
          const response = await fetch(UPLOAD_IMAGE_API, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              files: multiImg,
            }),
          });

          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }

          const data = await response.json();

          if (response.ok) {
            dispatch(
              updateExchangeSettingsDetails({
                key: exchangeSettingsActionTypes.UPDATE_IMAGE_LIST,
                value: data.toString().replace(/,/g, ";"),
              })
            );

            setIsLoader(null);
          }
        } catch (error) {
          if (error.message.includes('500')) {
            setIsInternalServerError(true);
          }
        }
      })();
    }
  }, [multiImg]);

  const uploadHandler = () => {
    if (exchangeSettingsState.navigateForward === "/exchange") {
      navigate("/ExchangePayment");
    }
    if (exchangeSettingsState.navigateForward === "/photo") {
      if (refundSettingsState.enableIncentive) {
        navigate("/refund");
      } else {
        navigate("/RefundOptions");
      }
    }
  };

  /* Navigate to Previous Page */
  const backHandler = () => {
    window.history.back();
  };

  return (
    <main className="photo">
      {isInternalServerError && <Toast type="error" />}
      <div className="saara__container">
        <div className="saara-justify-content-center row__title">
          <Link to="" onClick={backHandler} className="btn__small_screen">
            <img src="assets/svg/chevron_left.svg" width="24" alt="back" />
          </Link>
          <div>
            <HeaderText
              text={storeConfigState?.themeConfig?.image_upload_page_title}
              extraText=""
            />
          </div>
        </div>
        <div className="saara-justify-content-center photo__row">
          {multiImg?.map((item, index) => {
            return (
              <div
                className={`photo__card photo__one saara-justify-content-center`}
                key={index}
              >
                {isLoader === item ? (
                  <div className="photo__load">
                    <p className="photo__load_text">
                      {
                        storeConfigState?.themeConfig
                          ?.image_upload_page_uploading_message
                      }
                    </p>
                    <div className="progress-bar-container">
                      <div className="progress-bar">
                        <div className="progress-bar-value"></div>
                      </div>
                    </div>
                  </div>
                ) : isVideo ? (
                  <video width="320" height="240" controls>
                    <source src={item} type="video/mp4" />
                    Your browser does not support the video tag.
                  </video>
                ) : (
                  <img
                    src={item}
                    className="photo__card_add"
                    alt="photo_container"
                    width="200"
                    height="290"
                  />
                )}
                <span
                  className="photo__card_delete"
                  onClick={() => {
                    setShowAddMore(true);
                    removeImgHandler(index);
                  }}
                > 
                  <IoMdClose className="photo__card_icon" />
                  {/* <img
                    src="assets/svg/delete.svg"
                    alt="close"
                    className="photo__card_icon"
                    onClick={() => removeImgHandler(index)}
                  /> */}
                </span>
                <div className="photo__load saara-d-none">
                  <p className="photo__load_text">Uploading your files</p>
                  <div className="photo__load_line">
                    <span className="photo__load_progress"></span>
                  </div>
                </div>
              </div>
            );
          })}
          <div
            className={` ${
              showAddMore ? "" : "saara-d-none"
            } photo__card  photo__one  saara-justify-content-center `}
          >
            <div
              className={`saara-justify-content-center photo__empty call_table`}
            >
              <span
                className={`multi  ${multi === true ? "" : "saara-d-none"}`}
              >
                <label
                  htmlFor="cameraFileInput"
                  className="saara-justify-content-center saara-cursor-pointer camera-file-input"
                >
                  <img
                    src="assets/svg/photo-icon.svg"
                    alt="camera"
                    className="saara-cursor-pointer one upload-img-icon"
                  />
                  <input
                    className="saara-d-none"
                    id="cameraFileInput"
                    type="file"
                    accept=".svg,.jpg,.jpeg.,.gif,.png,.webp,.mp4"
                    onChange={(e) => {
                      setImgPreview(e);
                    }}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                  />
                </label>
              </span>
            </div>
          </div>

          {multiImg.length === 0 && (
            <div
              className={`photo__card  photo__one  saara-justify-content-center`}
            >
              <div
                className={`justify-content-center align-items-center photo__empty call_table ${
                  multiImg?.length > 0 && multi === false ? "saara-d-none" : ""
                } `}
              >
                <label
                  htmlFor="cameraFileInput"
                  className="  saara-justify-content-center  saara-cursor-pointer camera-file-input"
                >
                  <img
                    src="assets/svg/photo-icon.svg"
                    alt="camera"
                    className="saara-cursor-pointer two upload-img-icon"
                  />
                  <input
                    className="saara-d-none"
                    id="cameraFileInput"
                    type="file"
                    accept=".svg,.jpg,.jpeg.,.gif,.png,.webp,.mp4"
                    capture="environment"
                    onChange={(e) => {
                      setImgPreview(e);
                    }}
                    onClick={(event) => {
                      event.target.value = null;
                    }}
                  />
                </label>
              </div>
            </div>
          )}
          {isError && (
            <div className="saara-justify-content-center">
              <span className="info__error error-items">{errorMsg}</span>
            </div>
          )}
        </div>

        <div className="btns">
          <div className=" btn__big_screen margin-right-20">
            <button
              href="!#"
              className="saara_custom_btn saara__btn btn__back back-page"
              onClick={backHandler}
            >
              {storeConfigState?.themeConfig?.back_button_label}
            </button>
          </div>

          <div>
            <Button
              name={storeConfigState?.themeConfig?.continue_button_label}
              onClick={uploadHandler}
              disabled={isBtnDisabled}
            />
          </div>
        </div>
        <div></div>
      </div>
    </main>
  );
};
